/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_SCHOOL_CONTENT = '[School] Get School Content',
  GET_SCHOOL_CONTENT_SUCCESS = '[School] Get School Content Success',
  GET_SCHOOL_CONTENT_FAILED = '[School] Get School Content Failed',

  CREATE_SCHOOL_CONTENT = '[School] Create School Content',
  CREATE_SCHOOL_CONTENT_SUCCESS = '[School] Create School Content Success',
  CREATE_SCHOOL_CONTENT_FAILED = '[School] Create School Content Failed',

  UPDATE_SCHOOL_CONTENT = '[School] Update School Content',
  UPDATE_SCHOOL_CONTENT_SUCCESS = '[School] Update School Content Success',
  UPDATE_SCHOOL_CONTENT_FAILED = '[School] Update School Content Failed',

  GET_SCHOOL_SETTINGS = '[School] Get School Settings',
  GET_SCHOOL_SETTINGS_SUCCESS = '[School] Get School Settings Success',
  GET_SCHOOL_SETTINGS_FAILED = '[School] Get School Settings Failed',

  CREATE_SCHOOL_SETTINGS = '[School] Create School Settings',
  CREATE_SCHOOL_SETTINGS_SUCCESS = '[School] Create School Settings Success',
  CREATE_SCHOOL_SETTINGS_FAILED = '[School] Create School Settings Failed',

  UPDATE_SCHOOL_SETTINGS = '[School] Update School Settings',
  UPDATE_SCHOOL_SETTINGS_SUCCESS = '[School] Update School Settings Success',
  UPDATE_SCHOOL_SETTINGS_FAILED = '[School] Update School Settings Failed',

  GET_SCHOOL_YEAR = '[School] Get School Year',
  GET_SCHOOL_YEAR_SUCCESS = '[School] Get School Year Success',
  GET_SCHOOL_YEAR_FAILED = '[School] Get School Year Failed',

  CREATE_SCHOOL_YEAR = '[School] Create School Year',
  CREATE_SCHOOL_YEAR_SUCCESS = '[School] Create School Year Success',
  CREATE_SCHOOL_YEAR_FAILED = '[School] Create School Year Failed',

  UPDATE_SCHOOL_YEAR = '[School] Update School Year',
  UPDATE_SCHOOL_YEAR_SUCCESS = '[School] Update School Year Success',
  UPDATE_SCHOOL_YEAR_FAILED = '[School] Update School Year Failed',

  GET_SCHOOL_YEAR_TERMS = '[School] Get School Year Terms',
  GET_SCHOOL_YEAR_TERMS_SUCCESS = '[School] Get School Year Terms Success',
  GET_SCHOOL_YEAR_TERMS_FAILED = '[School] Get School Year Terms Failed',

  CREATE_SCHOOL_YEAR_TERMS = '[School] Create School Year Terms',
  CREATE_SCHOOL_YEAR_TERMS_SUCCESS = '[School] Create School Year Terms Success',
  CREATE_SCHOOL_YEAR_TERMS_FAILED = '[School] Create School Year Terms Failed',

  UPDATE_SCHOOL_YEAR_TERMS = '[School] Update School Year Terms',
  UPDATE_SCHOOL_YEAR_TERMS_SUCCESS = '[School] Update School Year Terms Success',
  UPDATE_SCHOOL_YEAR_TERMS_FAILED = '[School] Update School Year Terms Failed',

  GET_SCHOOL_YEAR_PERIOD = '[School] Get School Year Period',
  GET_SCHOOL_YEAR_PERIOD_SUCCESS = '[School] Get School Year Period Success',
  GET_SCHOOL_YEAR_PERIOD_FAILED = '[School] Get School Year Period Failed',

  CREATE_SCHOOL_YEAR_PERIOD = '[School] Create School Year Period',
  CREATE_SCHOOL_YEAR_PERIOD_SUCCESS = '[School] Create School Year Period Success',
  CREATE_SCHOOL_YEAR_PERIOD_FAILED = '[School] Create School Year Period Failed',

  UPDATE_SCHOOL_YEAR_PERIOD = '[School] Update School Year Period',
  UPDATE_SCHOOL_YEAR_PERIOD_SUCCESS = '[School] Update School Year Period Success',
  UPDATE_SCHOOL_YEAR_PERIOD_FAILED = '[School] Update School Year Period Failed',

  GET_SCHOOL_YEAR_EVENTS = '[School] Get School Year Events',
  GET_SCHOOL_YEAR_EVENTS_SUCCESS = '[School] Get School Year Events Success',
  GET_SCHOOL_YEAR_EVENTS_FAILED = '[School] Get School Year Events Failed',

  CREATE_SCHOOL_YEAR_EVENTS = '[School] Create School Year Events',
  CREATE_SCHOOL_YEAR_EVENTS_SUCCESS = '[School] Create School Year Events Success',
  CREATE_SCHOOL_YEAR_EVENTS_FAILED = '[School] Create School Year Events Failed',

  UPDATE_SCHOOL_YEAR_EVENTS = '[School] Update School Year Events',
  UPDATE_SCHOOL_YEAR_EVENTS_SUCCESS = '[School] Update School Year Events Success',
  UPDATE_SCHOOL_YEAR_EVENTS_FAILED = '[School] Update School Year Events Failed',

  GET_FORM_PROGRAMS = '[School] Get Form Programs',
  GET_FORM_PROGRAMS_SUCCESS = '[School] Get Form Programs Success',
  GET_FORM_PROGRAMS_FAILED = '[School] Get Form Programs Failed',

  GET_PROFESSOR_LIST = '[School] Get Professor List',
  GET_PROFESSOR_LIST_SUCCESS = '[School] Get Professor List Success',
  GET_PROFESSOR_LIST_FAILED = '[School] Get Professor List Failed',
}

// SCHOOL CONTENT ACTIONS
export const getSchoolContent = createAction(
  ActionTypes.GET_SCHOOL_CONTENT
);

export const getSchoolContentSuccess = createAction(
	ActionTypes.GET_SCHOOL_CONTENT_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolContentFailed = createAction(
  ActionTypes.GET_SCHOOL_CONTENT_FAILED,
  props<{ data: any }>()
);

export const createSchoolContent = createAction(
  ActionTypes.CREATE_SCHOOL_CONTENT,
  props<{ data: any }>()
);

export const createSchoolContentSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_CONTENT_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolContentFailed = createAction(
  ActionTypes.CREATE_SCHOOL_CONTENT_FAILED,
  props<{ data: any }>()
);

export const updateSchoolContent = createAction(
  ActionTypes.UPDATE_SCHOOL_CONTENT,
  props<{ data: any, SchoolId: any }>()
);

export const updateSchoolContentSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_CONTENT_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolContentFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_CONTENT_FAILED,
  props<{ data: any }>()
);

// SCHOOL SETTINGS ACTIONS
export const getSchoolSettings = createAction(
  ActionTypes.GET_SCHOOL_SETTINGS
);

export const getSchoolSettingsSuccess = createAction(
	ActionTypes.GET_SCHOOL_SETTINGS_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolSettingsFailed = createAction(
  ActionTypes.GET_SCHOOL_SETTINGS_FAILED,
  props<{ data: any }>()
);

export const createSchoolSettings = createAction(
  ActionTypes.CREATE_SCHOOL_SETTINGS,
  props<{ data: any }>()
);

export const createSchoolSettingsSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_SETTINGS_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolSettingsFailed = createAction(
  ActionTypes.CREATE_SCHOOL_SETTINGS_FAILED,
  props<{ data: any }>()
);

export const updateSchoolSettings = createAction(
  ActionTypes.UPDATE_SCHOOL_SETTINGS,
  props<{ data: any, buildingId: any }>()
);

export const updateSchoolSettingsSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_SETTINGS_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolSettingsFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_SETTINGS_FAILED,
  props<{ data: any }>()
);

// SCHOOL YEAR ACTIONS
export const getSchoolYear = createAction(
  ActionTypes.GET_SCHOOL_YEAR
);

export const getSchoolYearSuccess = createAction(
	ActionTypes.GET_SCHOOL_YEAR_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolYearFailed = createAction(
  ActionTypes.GET_SCHOOL_YEAR_FAILED,
  props<{ data: any }>()
);

export const createSchoolYear = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR,
  props<{ data: any }>()
);

export const createSchoolYearSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_YEAR_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolYearFailed = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_FAILED,
  props<{ data: any }>()
);

export const updateSchoolYear = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR,
  props<{ data: any, roomId: any }>()
);

export const updateSchoolYearSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_YEAR_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolYearFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_FAILED,
  props<{ data: any }>()
);

// SCHOOL YEAR TERMS ACTIONS
export const getSchoolYearTerms = createAction(
  ActionTypes.GET_SCHOOL_YEAR_TERMS
);

export const getSchoolYearTermsSuccess = createAction(
	ActionTypes.GET_SCHOOL_YEAR_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolYearTermsFailed = createAction(
  ActionTypes.GET_SCHOOL_YEAR_TERMS_FAILED,
  props<{ data: any }>()
);

export const createSchoolYearTerms = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_TERMS,
  props<{ data: any }>()
);

export const createSchoolYearTermsSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_YEAR_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolYearTermsFailed = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_TERMS_FAILED,
  props<{ data: any }>()
);

export const updateSchoolYearTerms = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_TERMS,
  props<{ data: any, collegeId: any }>()
);

export const updateSchoolYearTermsSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_YEAR_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolYearTermsFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_TERMS_FAILED,
  props<{ data: any }>()
);

// SCHOOL YEAR PERIOD ACTIONS
export const getSchoolYearPeriod = createAction(
  ActionTypes.GET_SCHOOL_YEAR_PERIOD
);

export const getSchoolYearPeriodSuccess = createAction(
	ActionTypes.GET_SCHOOL_YEAR_PERIOD_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolYearPeriodFailed = createAction(
  ActionTypes.GET_SCHOOL_YEAR_PERIOD_FAILED,
  props<{ data: any }>()
);

export const createSchoolYearPeriod = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_PERIOD,
  props<{ data: any }>()
);

export const createSchoolYearPeriodSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_YEAR_PERIOD_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolYearPeriodFailed = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_PERIOD_FAILED,
  props<{ data: any }>()
);

export const updateSchoolYearPeriod = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_PERIOD,
  props<{ data: any, departmentId: any }>()
);

export const updateSchoolYearPeriodSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_YEAR_PERIOD_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolYearPeriodFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_PERIOD_FAILED,
  props<{ data: any }>()
);

// SCHOOL YEAR EVENTS ACTIONS
export const getSchoolYearEvents = createAction(
  ActionTypes.GET_SCHOOL_YEAR_EVENTS
);

export const getSchoolYearEventsSuccess = createAction(
	ActionTypes.GET_SCHOOL_YEAR_EVENTS_SUCCESS,
  props<{ data: any }>()
);

export const getSchoolYearEventsFailed = createAction(
  ActionTypes.GET_SCHOOL_YEAR_EVENTS_FAILED,
  props<{ data: any }>()
);

export const createSchoolYearEvents = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_EVENTS,
  props<{ data: any }>()
);

export const createSchoolYearEventsSuccess = createAction(
	ActionTypes.CREATE_SCHOOL_YEAR_EVENTS_SUCCESS,
  props<{ data: any }>()
);

export const createSchoolYearEventsFailed = createAction(
  ActionTypes.CREATE_SCHOOL_YEAR_EVENTS_FAILED,
  props<{ data: any }>()
);

export const updateSchoolYearEvents = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_EVENTS,
  props<{ data: any, courseId: any }>()
);

export const updateSchoolYearEventsSuccess = createAction(
	ActionTypes.UPDATE_SCHOOL_YEAR_EVENTS_SUCCESS,
  props<{ data: any }>()
);

export const updateSchoolYearEventsFailed = createAction(
  ActionTypes.UPDATE_SCHOOL_YEAR_EVENTS_FAILED,
  props<{ data: any }>()
);

// FORM PROGRAM ACTIONS
export const getFormPrograms = createAction(
  ActionTypes.GET_FORM_PROGRAMS
);

export const getFormProgramsSuccess = createAction(
	ActionTypes.GET_FORM_PROGRAMS_SUCCESS,
  props<{ data: any }>()
);

export const getFormProgramsFailed = createAction(
  ActionTypes.GET_FORM_PROGRAMS_FAILED,
  props<{ data: any }>()
);

// PROFESSOR ACTIONS
export const getProfessorList = createAction(
  ActionTypes.GET_PROFESSOR_LIST
);

export const getProfessorListSuccess = createAction(
	ActionTypes.GET_PROFESSOR_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getProfessorListFailed = createAction(
  ActionTypes.GET_PROFESSOR_LIST_FAILED,
  props<{ data: any }>()
);